<template>
    <div>
      <div class="my_flex">
        <!-- 需求大厅发布 -->
          <div @click="sendWays1" :class='isSendWays1? "pro_col_item checked":"pro_col_item"'>
            <el-row class="pro_sendWays_btnImg_checked" justify="space-around">
              <el-col :span="12" class="pro_sendWays_img"><img src="../../../../public/img/addProject/qwfb.png"
                 ></el-col>
              <el-col :span="12" class="pro_sendWays_btncheck"><img :src='isSendWays1?workTypeImg.isSelected:workTypeImg.unSelected'></el-col>
            </el-row>
            <div class="pro_sendWays_row">
              <p class="pro_sendWays_title">需求大厅发布</p>
              <p class="pro_sendWays_tips">全网发布，所有工种的师傅都能看到</p>
            </div>
          </div>
        <!-- 师傅发布 -->
          <div @click="sendWays2" :class='isSendWays2? "pro_col_item checked":"pro_col_item"'>
            <el-row class="pro_sendWays_btnImg_checked" justify="space-around">
              <el-col :span="12" class="pro_sendWays_img"><img src="../../../../public/img/addProject/sffb.png"
                 ></el-col>
              <el-col :span="12" class="pro_sendWays_btncheck"><img :src='isSendWays2?workTypeImg.isSelected:workTypeImg.unSelected'></el-col>
            </el-row>
            <div class="pro_sendWays_row">
              <p class="pro_sendWays_title">师傅发布</p>
              <p class="pro_sendWays_tips">发布给本企业的指定师傅</p>
            </div>
          </div>
        <!-- 群组发布 -->
          <div @click="sendWays3" :class='isSendWays3? "pro_col_item checked":"pro_col_item"' >
            <el-row class="pro_sendWays_btnImg_checked" justify="space-around">
              <el-col :span="12" class="pro_sendWays_img"><img src="../../../../public/img/addProject/qzfb.png"
                 ></el-col>
              <el-col :span="12" class="pro_sendWays_btncheck"><img :src='isSendWays3?workTypeImg.isSelected:workTypeImg.unSelected'></el-col>
            </el-row>
            <div class="pro_sendWays_row">
              <p class="pro_sendWays_title">群组发布</p>
              <p class="pro_sendWays_tips">发布给本企业的师傅群组</p>
            </div>
          </div>
      </div>
      <div class="man_list" v-if="isSendWays2||isSendWays3">
        <div class="ava_img" v-for="(item,index) in manArr" :key="index">
          <div class="ava_b">
            <img src="../../../../public/img/default-avatar.png"></img>
            <img class="delThis" src="../../../../public/img/orderInfo2/icon_del.png"></img>
          </div>
          <div class="ava_name">{{item.name}}</div>
        </div>
      </div>
    </div>
</template>

<script>
  export default{
    data(){
      return {
        workTypeImg: {
          isSelected:require('../../../../public/img/addProject/checked.png'),
          unSelected:require('../../../../public/img/addProject/unchecked.png'),
        },
        isSendWays1:false,
        isSendWays2:false,
        isSendWays3:false,
        manArr: [
          {url: '',name: '张三1'},
          {url: '',name: '张三1'}
        ]
      }
    },
    methods:{
       sendWays1(){
        this.clearSendw()
        this.isSendWays1=!this.isSendWays1
      },
      sendWays2(){
        this.clearSendw()
        this.isSendWays2=!this.isSendWays2
      },
      sendWays3(){
        this.clearSendw()
        this.isSendWays3=!this.isSendWays3
      },
      clearSendw(){
        this.isSendWays1=false
        this.isSendWays2=false
        this.isSendWays3=false
      },
    }
  }
</script>

<style lang="scss" scoped>
  .my_flex{
    display: flex;
    .checked{
      border: 2px solid rgba(61, 126, 255, 1);
    }
    .pro_col_item {
      background: rgba(251, 251, 252, 1);
      border-radius: 3px;
      text-align: center;
      height: auto;
      width: 30%;
      min-height: 208px;
      min-width: 169px;
      box-sizing: border-box;
    }
    .pro_col_item+.pro_col_item{
      margin-left: 12px;
    }
  }

  .pro_sendWays_btnImg_checked {
    margin-top: 30px;
    span {
      display: inline-block;
      margin-top: 25px;
      margin-bottom: 30px;
      width: 50px;
      height: 50px;
    }
  }
  .pro_sendWays_btnImg {
    border: 1px solid rgba(237, 239, 242, 1);
    background: rgba(251, 251, 252, 1);
    border-radius: 3px;
  }

  .pro_sendWays_row {
    text-align: center;
    margin-left: 11%;
    margin-bottom: 19px;
    margin-top: 20px;
    padding-bottom: 10px;
  }

  .pro_sendWays_title {
    font-size: 14px;
    font-weight: 500;
    color: rgba(25, 31, 37, 1);
    line-height: 20px;
  }

  .pro_sendWays_tips {
    font-size: 12px;
    font-weight: 400;
    color: rgba(144, 147, 153, 1);
    line-height: 17px;
    margin-top: 10px;
    width: 90%;
  }

  .pro_sendWays_btncheck {
    margin-top: 10px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }

  .pro_sendWays_img img {
    width: 50px;
    height: 50px;
    margin-left: 10px;
  }

  .man_list {
    display: flex;
    background: rgba(251, 251, 252, 1);
    margin-top: 12px;
    padding-left: 34px;
    height: auto;
    width: auto;
    flex-wrap: wrap;
    .ava_img {
      min-width: 50px;
      text-align: center;
      padding-top: 12px;
      img {
        width: 32px;
        height: 32px;
      }
      view:nth-of-type(1) {
        width: 32px;
        height: 32px;
        text-align: center;
        margin: auto;
      }
    }
    .ava_name {
      font-size: 12px;
      color: rgba(25, 31, 37, 0.8);
      min-width: 50px;
    }
    .ava_b{
      position: relative;
      .delThis{
        width: 10px;
        height: 10px;
        position: absolute;
        top: 0px;
        right: 5px;
        cursor: pointer;
      }
    }
  }
</style>
